import {
    API_REQUEST,
    GET_RFR_NOTICES,
    FILE_RFR,
    SUBMIT_RFR
} from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getRfrNotices = (rollNum: string): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/rfr/get-notices/${rollNum}`,
        next: GET_RFR_NOTICES,
        method: 'GET',
        authorization: true
    })
})

export const fileRfr = (formdata: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/rfr/filerfr`,
        next: FILE_RFR,
        method: 'POST',
        data: formdata,
        authorization: true
    })
})

export const submitRfr = (formdata: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/rfr/submitrfr`,
        next: SUBMIT_RFR,
        method: 'POST',
        data: formdata,
        authorization: true
    })
})
